/* eslint-disable indent */
/* eslint-disable camelcase */
/* eslint-disable jsx-quotes */
import React from 'react';
import moment from 'moment';

import './styles.css';

export default class ItemOptionSelectQuestionPresentation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            checkedQuestion: false,
        };
    }

    componentDidMount() {
        const { checkedQuestion } = this.props;
        this.setState({ checkedQuestion });
    }

    componentDidUpdate(prevProps, prevState) {
        const { handleChecked } = this.props;

        if (prevProps.checkedQuestion !== this.props.checkedQuestion) {
            this.setState({ checkedQuestion: this.props.checkedQuestion });
        }

        if (prevState.checkedQuestion !== this.state.checkedQuestion) {
            handleChecked({ check: this.state.checkedQuestion });
        }
    }

    getStatusQuestion({ status }) {
        switch (status) {
            case 'INCOMPLETE':
                return 'Incompleto';
            case 'READY':
                return 'Completo';
            case 'LINKED':
                return 'Vinculado';
            case 'LINKED_ANSWERED':
                return 'Respondido';
            default:
                return 'Não identificado';
        }
    }

    render() {
        const {
            question,
            handleShowAllContent,
            showAllContent,
            questionDisabled,
        } = this.props;
        const { checkedQuestion } = this.state;

        return (
            <div
                className={`container-question-details ${
                    !question.enabled ? 'disable-question-with-select' : ''
                } ${questionDisabled ? 'disable-question' : ''}`}
            >
                <strong className="alert-disable-question">
                    {!question.enabled ? 'Questão desabilitada' : ''}
                </strong>
                <span className="header">
                    <span className="description">
                        <input
                            disabled={questionDisabled}
                            value={checkedQuestion}
                            type="checkbox"
                            checked={checkedQuestion}
                            name="checkedQuestion"
                            onChange={({ target }) =>
                                this.setState({
                                    checkedQuestion: target.checked,
                                })
                            }
                        />
                        <p>{question.title}</p>
                    </span>
                    <span className="line-actions">
                        <button
                            className="show-text-button"
                            type="button"
                            onClick={() => handleShowAllContent(showAllContent)}
                        >
                            {showAllContent ? 'Ocultar' : 'Mostrar'}
                        </button>
                    </span>
                </span>
                <span className="other-description">
                    {question.created_at && (
                        <p>
                            <strong>Criado em:</strong>{' '}
                            {moment(question.created_at).format('DD/MM/YYYY')}
                        </p>
                    )}
                    {question.updated_at && (
                        <p>
                            <strong>Editado em:</strong>{' '}
                            {moment(question.updated_at).format('DD/MM/YYYY')}
                        </p>
                    )}
                    {question.status && (
                        <p>
                            <strong>Status:</strong>{' '}
                            {this.getStatusQuestion({
                                status: question.status,
                            })}
                        </p>
                    )}
                </span>
                {showAllContent && (
                    <span className="content-more-option">
                        <strong>{question.title}</strong>
                        <section className="content-items">
                            {question.options.map(option => (
                                <div
                                    key={option.id}
                                    className={`option ${
                                        !option.enabled ? 'disable-item' : ''
                                    }`}
                                >
                                    <span
                                        className={
                                            !(
                                                option.id ===
                                                question.correct_option_id
                                            )
                                                ? 'indicate-correct'
                                                : 'indicate-correct highlight-correct'
                                        }
                                    >
                                        {option.id ===
                                            question.correct_option_id && (
                                            <span className="checkmark"></span>
                                        )}
                                    </span>
                                    <p>{option.title}</p>
                                </div>
                            ))}
                        </section>
                    </span>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/selection-questions/ItemOptionSelectQuestion/ItemOptionSelectQuestionPresentation.js